import { formatDollarsAsUsd } from "@src/appV2/lib/Money/utils/currency";

import { type Faq } from "../components/TaxationFaqs";

interface GetFaqsWhenEligibleToPayTaxParams {
  formIssuanceThresholdInDollars: number;
  taxationYear: number;
}

export function getFaqsWhenEligibleToPayTax(params: GetFaqsWhenEligibleToPayTaxParams): Faq[] {
  const { formIssuanceThresholdInDollars, taxationYear } = params;

  return [
    {
      question: "How do I download my tax form?",
      answer: [
        {
          message: `1. Log into Stripe Express with your email and phone verification code
2. Find the "Tax Forms" section
3. Look for your 1099-NEC form
4. Download it and save it`,
        },
      ],
    },
    {
      question: "I lost my tax form. What do I do?",
      answer: [
        {
          message:
            "You can download your form again anytime from Stripe Express. Just log back in and go to the Tax Forms section. If you have problems, contact Stripe support.",
        },
      ],
    },
    {
      question: "What if my tax form doesn't match what I thought I earned?",
      answer: [
        {
          message: `A few things might be different:

InstantPay Fees: Your tax form includes $2.99 fees you paid to get paid right away. These fees are added to your total earnings on your 1099, even though they came out of your paycheck.

When Payment Was Made: Your tax form is based on when money actually reached your account, not when you worked the shift. So if you worked a shift on December 31st but got paid on January 1st, it might show up on a different year's form.

If something doesn't look right, you can ask for a list of all the payments that were used to figure out your 1099. Just reach out to us via chat!`,
        },
      ],
    },
    {
      question: "I can't log in to my Stripe Express account",
      answer: [
        {
          title: "My phone number changed or I lost it",
          message: `Don't worry! You can still log in and update your number. Here's how:

1. Go to express.stripe.com
2. Enter the email address for your account
3. When it asks for a 6-digit verification code, look for the option that says "I no longer have access to this phone number"
4. Click it
5. Follow the steps to verify it's really you
6. Add your new phone number
7. You're back in!
`,
        },
        {
          title: "Other login problems",
          message:
            "If you're having trouble logging in for any other reason, contact Stripe support directly. They can help get you back into your account.",
        },
      ],
    },
    {
      question: "I don't work for Clipboard anymore. Can I still get my tax form?",
      answer: [
        {
          message: `Yes! If you earned ${formatDollarsAsUsd(formIssuanceThresholdInDollars, {
            maximumFractionDigits: 0,
          })} or more in ${taxationYear}, you'll still get your form. You don't need to keep working to receive it, and you don't need access to your Clipboard account.`,
        },
      ],
    },
    {
      question: "When is tax day?",
      answer: [
        {
          message: `April 15, ${
            taxationYear + 1
          } is the deadline to file your taxes. Make sure you have your 1099-NEC form ready!`,
        },
      ],
    },
    {
      question: "I still have questions. Who do I contact?",
      answer: [
        {
          message: `- For Clipboard questions: Use the app (Account > Get Help > Contact Support)
- For Stripe or tax form questions: Contact Stripe support directly
- For tax advice: Talk to a tax professional`,
        },
      ],
    },
    {
      question: "Can Clipboard tell me how many miles I drove for shifts this year?",
      answer: [
        {
          message: `Yes, we will send you a log of your ${taxationYear} shifts with estimated mileage via email the first week of January.`,
        },
      ],
    },
  ];
}
